import React from 'react';
import { motion } from 'framer-motion';
import { FileText, BarChart2, ArrowRightLeft, Calendar } from 'lucide-react';

const operationsData = [
  {
    icon: <FileText className="h-6 w-6" />,
    title: 'Contract Duration',
    detail: '12 Months Fixed Tenure'
  },
  {
    icon: <BarChart2 className="h-6 w-6" />,
    title: 'Transparency & Reporting',
    detail: 'Monthly sales reports & digital tracking'
  },
  {
    icon: <ArrowRightLeft className="h-6 w-6" />,
    title: 'Payout Terms',
    detail: 'Revenue share paid monthly'
  },
  {
    icon: <Calendar className="h-6 w-6" />,
    title: 'Exit & Renewal',
    detail: 'Renewal option or full settlement'
  }
];

const Operations = () => {
  return (
    <section className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#10B981]">Operations & Terms</span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#022C22] mt-4 mb-4">
            Clear, Transparent Framework
          </h2>
          <p className="text-base leading-relaxed text-[#4B5563] max-w-2xl mx-auto">
            Everything you need to know about investment terms and operations
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {operationsData.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-[#E5E7EB] rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 p-6"
            >
              <div className="bg-[#D1FAE5] w-12 h-12 rounded-xl flex items-center justify-center text-[#10B981] mb-4">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-[#022C22] mb-2">{item.title}</h3>
              <p className="text-sm text-[#4B5563]">{item.detail}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-[#064E3B] text-white rounded-2xl shadow-xl p-8 md:p-12"
        >
          <h3 className="text-2xl font-semibold tracking-tight text-white mb-6">What LIVENEAT Handles</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold text-[#10B981] mb-3">Operations</h4>
              <ul className="space-y-2 text-sm text-[#F3F0E6]">
                <li>• Machine procurement & installation</li>
                <li>• Location acquisition (offices, societies)</li>
                <li>• Inventory management & restocking</li>
                <li>• Maintenance & servicing</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-[#10B981] mb-3">Technology & Support</h4>
              <ul className="space-y-2 text-sm text-[#F3F0E6]">
                <li>• Payment systems & analytics</li>
                <li>• Real-time performance tracking</li>
                <li>• Customer support 24/7</li>
                <li>• Digital transaction monitoring</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Operations;
